import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import DocumentMeta from 'react-document-meta';
import config from '../config';

const meta = {
  title: 'How to Use Abortion Pills | Free medication abortion',
  description: '',
  meta: {
    charset: 'utf-8',
    name: {
      keywords: '',
    },
    property: {
      'og:title': 'How to Use Abortion Pills | Free medication abortion',
      'og:description': '',
      'og:image': '',
    },
  },
};

export default function AbortionPillsUse() {
  const [cmsData, setCmsData] = useState(undefined);
  const [genericMessage, setGenericMessage] = useState('');
  const [messageType, setMessageType] = useState('success');
  const { token } = useParams();

  useEffect(() => {
    const errorMessage =
      'Unable to confirm your request. Please try again later or create a new contact request.';
    const successMessage =
      'Your request has been sent to the relevant contact. Please wait for them to get in touch.';
    const validateToken = async () => {
      try {
        const response = await fetch(
          `${config.apiBaseUrl}/kit-request-confirm/${token}`,
        );

        if (!response.ok) {
          setGenericMessage(errorMessage);
          setMessageType('error');
        } else {
          setGenericMessage(successMessage);
          setMessageType('success');
        }
      } catch {
        setGenericMessage(errorMessage);
        setMessageType('error');
      }
    };

    console.log('Here::: ', token);

    if (token) {
      validateToken();
    }
  }, [token]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${config.contentBaseUrl}/content/item/htuap`,
        );
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        if (result._id) {
          setCmsData(result);
        }
      } catch (error) {
        console.log(error.message);
      } finally {
        //
      }
    };

    fetchData();
  }, []);

  return (
    <DocumentMeta {...meta}>
      <div className="abortion-pill-usage-page">
        <div className="page-title dark-background text-start contact-bg">
          <div className="container position-relative">
            {cmsData && <h1>{cmsData.title}</h1>}
          </div>
        </div>

        <section className="abortion-pill-usage section light-background py-4 border-bottom">
          {genericMessage && (
            <div className="container py-5">
              <div
                className={`mt-3 alert alert-${messageType === 'success' ? 'success' : 'danger'}`}
              >
                {genericMessage}
              </div>
            </div>
          )}
          {cmsData && (
            <div
              className="container section-title pb-0 cms-content"
              dangerouslySetInnerHTML={{ __html: cmsData.content || '' }}
            ></div>
          )}
        </section>
      </div>
    </DocumentMeta>
  );
}
